class Popout {
  obj = {};

  apply = data => {
    this.obj = data;
  };

  add = (componentName, value) => {
    this.obj[componentName] = value;
  };

  get = componentName => {
    return this.obj[componentName];
  };

  getAll = () => {
    return this.obj;
  };

  delete = componentName => {
    this.obj[componentName] = undefined;
  };

  deleteAll = () => {
    this.obj = {};
  };
}

export default new Popout();
